// extracted by mini-css-extract-plugin
module.exports = {"message":"_2N-GmEzSULm8UeOTmW589t","nx-alert__title":"_2PYYIwsKUgZOJbysqe2678","nx-alert__body":"_2zQCSB0wth9oPqh8rnCxP0","tooltipPopover":"_3MlYtSMorFYmlex-yltw4X"};